'use client';

import { tracking } from '@/hotdesk-ui/services/tracking.service';
import { useEffect } from 'react';

/**
 * Fires onScreenChange for the Explore/Workspaces screen (Discovery Funnel Step 3).
 * Source is derived automatically:
 *   - referrer is home page + URL has search params → "home_search"
 *   - referrer is home page, no search params       → "home"
 *   - any other origin                              → "navigation_bar"
 */
export default function ExploreTracking() {
  useEffect(() => {
    const referrer = document.referrer;
    const origin = window.location.origin;
    const hasSearchParams = window.location.search.length > 0;
    const cameFromHome = referrer.startsWith(origin) && (referrer === origin + '/' || referrer === origin);
    let source = 'navigation_bar';
    if (cameFromHome && hasSearchParams) {
      source = 'home_search';
    } else if (cameFromHome) {
      source = 'home';
    }
    tracking.onScreenChange('explore_list', window.location.href, source);
  }, []);
  return null;
}